"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var delimited_1 = require("./delimited");
var hoursMinutesSeconds_1 = require("./hoursMinutesSeconds");
var useLocalisation_1 = require("../../hooks/useLocalisation");
var hoursMinutesSeconds_i18n_1 = require("./hoursMinutesSeconds.i18n");
function formatValueForUnit(value, unit, language, override) {
    var strings = useLocalisation_1.getLocalisation(hoursMinutesSeconds_i18n_1.hoursMinutesSecondsTranslations, language);
    if (value === 0 || value === undefined) {
        if (override) {
            return unit === "time" ? "0" + strings.seconds : "0";
        }
        else {
            return undefined;
        }
    }
    return unit === "count"
        ? delimited_1.delimited({ value: value, round: true })
        : hoursMinutesSeconds_1.hoursMinutesSeconds(value, language);
}
exports.formatValueForUnit = formatValueForUnit;
